export const enToFa = (str: string | number): string => {
	return `${str}`.replace(/[0-9]/g, (w) => String.fromCharCode(w.charCodeAt(0) + 1728));
};

export const faToEn = (str: string | number): string => {
	return `${str}`.replace(/[۰-۹]/g, (w) => String.fromCharCode(w.charCodeAt(0) - 1728));
};
